import { useState, useRef, useEffect } from "react";
import { X } from "lucide-react";

interface EditableChipProps {
  value: string;
  onChange: (value: string) => void;
  onRemove: () => void;
}

export function EditableChip({ value, onChange, onRemove }: EditableChipProps) {
  const [editing, setEditing] = useState(false);
  const [text, setText] = useState(value);
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (editing && inputRef.current) {
      inputRef.current.focus();
      inputRef.current.select();
    }
  }, [editing]);

  const commit = () => {
    const trimmed = text.trim();
    if (trimmed) onChange(trimmed);
    else setText(value);
    setEditing(false);
  };

  return (
    <div className="chip-gloss group inline-flex items-center gap-2 py-1.5 pl-3 pr-1.5 max-w-[200px]"
         style={{ cursor: editing ? "text" : "pointer" }}>
      {editing ? (
        <input
          ref={inputRef}
          value={text}
          onChange={(e) => setText(e.target.value)}
          onBlur={commit}
          onKeyDown={(e) => {
            if (e.key === "Enter") commit();
            if (e.key === "Escape") {
              setText(value);
              setEditing(false);
            }
          }}
          className="bg-transparent outline-none text-sm font-medium text-slate-700 w-28"
          onClick={(e) => e.stopPropagation()}
        />
      ) : (
        <span
          onClick={() => setEditing(true)}
          className="text-sm font-medium text-slate-700 truncate"
          title="Klik om naam te wijzigen"
        >
          {value}
        </span>
      )}
      <button
        type="button"
        onClick={(e) => {
          e.stopPropagation();
          onRemove();
        }}
        className="p-1 rounded-md text-slate-400 hover:text-rose-500 hover:bg-rose-50 transition-colors"
      >
        <X size={21} />
      </button>
    </div>
  );
}
